// 引入自定义路由
import vxRouter from '@mlib/js/vx-router/index.js';
import * as libs from './get-libs/index.js';

import vue, { eventMixin } from './vue-event/vue-event.js';

import base from './base/base.js';
import dom from './dom/dom.js';
import http from './http/http.js';
// import oss from './oss/oss.js';
import ls from './local-storage/ls.js';

import * as mixin from './mixin/mixin.js';

import createPaging from './paging/paging.js';

import tool from './tool/index.js';
import sdk from './sdk/sdk.js';

import popup from './popup/index.js';
import module from './module/index.js';
import buildPrint  from './print/index.js';

import * as permission from './permission/permission.js';
import getPoster from './poster/util/dom';

var app = {
  vxRouter,
  libs,
  base,
  dom,
  vue,
  eventMixin,
  http,
  // oss,
  tool,
  ls,
  ...sdk,
  popup,
  module,
  mixin,
  buildPrint,
  createPaging,
  permission,
  getPoster,
};

Vue.prototype.app = window.app = app;

Vue.mixin(eventMixin);

vue.$on('instanceVueRouter', function(router) {
  app.router = router;
});

// 增加一些全局可用的配置项
app.config = {
  minDate: new Date(2020, 0, 1),
  maxDate: new Date(2030, 11, 31),
};
